<div
  class="trigger"
  tabindex="-1"
  [attr.aria-disabled]="disabled() || null"
  (click)="onTriggerClick($event)"
  (keydown)="onTriggerKeydown($event)"
>
  <ng-content />
</div>
